import { Button, Drawer, Empty } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import React, { memo } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { isEmpty } from 'lodash';
import {
  commonState,
  setMobileMenuDrawerClose,
  setLoaderShow,
  setProfileModalOpen,
} from '../../../app/base/commonSlice';
import Icons from '../../../configs/icon.config';
import { themeStyle } from '../../../app/theme/themeSlice';
import { CustomMenu } from '../SideNav/SideNav';
import { NotificationList } from '../../ui';
import UserProfile from '../Profile-modal/UserProfile';
import { authState } from '../../../app/auth/authSlice';

import noData from '../../../assets/no-data-icn.png';
import Translate from '../../ui/Translate';

interface DrawerProps {
  placement: 'top' | 'right' | 'bottom' | 'left';
  bodyStyle: React.CSSProperties;
  closable: boolean;
  open: boolean;
  maskClosable: boolean;
}

// Default props for the common Drawer component
const defaultDrawerProps: DrawerProps = {
  placement: 'bottom',
  bodyStyle: {},
  closable: false,
  open: false,
  maskClosable: true,
};

function MobileMenuDrawer({
  fetchNextPage,
  hasMore,
  notificationData,
  isLoading,
}: any) {
  const { profile } = useSelector(authState);
  const { mobileMenu } = useSelector(commonState);
  const myBracTheme = useSelector(themeStyle);
  const mode = myBracTheme.mode === 'light';
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const { profileModalOpen } = useSelector(commonState);

  const handleClose = () => {
    dispatch(
      setMobileMenuDrawerClose({
        isDrawerOpen: false,
        menuKey: 'isMobileNotificationClose',
      })
    );
  };

  const drawerProps: DrawerProps = {
    ...defaultDrawerProps,
    placement: 'bottom',
    bodyStyle: {
      background: mode ? '#fff' : '#323232',
    },
    closable: false,
    maskClosable: true,
  };

  const handleLogout = async () => {
    dispatch(setLoaderShow(false));
    localStorage.removeItem('MyBrac-admin');
    await keycloak?.logout();
  };

  const openUserProfile = () => {
    dispatch(
      setMobileMenuDrawerClose({
        isDrawerOpen: !mobileMenu?.isMobileProfileClose,
        menuKey: 'isMobileProfileClose',
      })
    );
    // setIsUserProfileOpen(true);
    dispatch(setProfileModalOpen(true));
  };

  const closeUserProfile = () => {
    dispatch(setProfileModalOpen(false));
  };

  const handleMenuClose = () => {
    dispatch(
      setMobileMenuDrawerClose({
        isDrawerOpen: false,
        menuKey: 'isMobileMenuDrawerClose',
      })
    );
  };

  const handleProfileClose = () => {
    dispatch(
      setMobileMenuDrawerClose({
        isDrawerOpen: false,
        menuKey: 'isMobileProfileClose',
      })
    );
  };

  return (
    <div>
      {/* menu drawer  */}
      <Drawer
        {...drawerProps}
        open={mobileMenu.isMobileMenuDrawerClose}
        style={{ borderTopLeftRadius: 20, borderTopRightRadius: 20 }}
        onClose={handleMenuClose}
      >
        <CustomMenu />
      </Drawer>
      {/* notification drawer  */}
      <Drawer
        {...drawerProps}
        onClose={handleClose}
        open={mobileMenu.isMobileNotificationClose}
        height={400}
        style={{ borderTopLeftRadius: 20, borderTopRightRadius: 20 }}
      >
        <>
          <div className="flex items-center justify-between">
            <div className="flex items-center h-[40px] gap-0 font-semibold text-[#212121] dark:text-white p-2 text-[16px]">
              <Translate en="Notifications" bn="নোটিফিকেশন" />
            </div>
            <button
              onClick={handleClose}
              className="text-[28px] text-pink-600 cursor-pointer"
            >
              {Icons.cross}
            </button>
          </div>
          <div className="border-b-2 dark:border-[#565657]" />
          {!isEmpty(notificationData) ? (
            <NotificationList
              hasMore={hasMore}
              data={notificationData}
              maxHeight="250"
              fetchNextPage={fetchNextPage}
              isLoading={isLoading}
            />
          ) : (
            <Empty
              style={{
                marginTop: 5,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
              description={
                <span className="font-semibold">
                  <Translate en="No notifications" bn="নোটিফিকেশন নেই" />
                </span>
              }
              image={noData}
              imageStyle={{ alignItems: 'center' }}
            />
          )}
        </>
      </Drawer>

      <Drawer
        {...drawerProps}
        height={220}
        style={{ borderTopLeftRadius: 20, borderTopRightRadius: 20 }}
        open={mobileMenu.isMobileProfileClose}
        onClose={handleProfileClose}
      >
        <div>
          <Button
            className="avatar-li"
            style={{ height: 50 }}
            type="text"
            onClick={() => openUserProfile()}
          >
            {Icons.profile}
            <Translate en="User profile" bn="ইউজার প্রোফাইল" />
          </Button>
          <hr />
          <Button
            type="text"
            style={{ height: 50 }}
            className="avatar-li"
            onClick={handleLogout}
          >
            {Icons.boxArrow}
            <Translate en="Logout" bn="লগ আউট" />
          </Button>
        </div>
        <hr />

        <UserProfile
          pin={profile?.staff_pin}
          visible={profileModalOpen}
          onClose={closeUserProfile}
          other={false}
        />
      </Drawer>
    </div>
  );
}

export default memo(MobileMenuDrawer);
